module.exports = __webpack_public_path__ + "img/step3_online.19e0b519.png";